var verseNavigationSelect = {
  init: function () {
    verseNavigationSelect.initializeSelect2();
  },

  /**
   * Initialize select element(s) with class 
   * .verse-navigation-container > .verse_id_navigation
   * with Select2 Jquery Plugin.
   */
  initializeSelect2: function () {
    $(".verse-navigation-container .verse_id_navigation").each(function () {
      $(this).select2();
    });

    verseNavigationSelect.beautifySelect2Container();
    $(".verse-navigation-container .verse_id_navigation").on(
      "change",
      verseNavigationSelect.gotoVerseId
    );
  },

  beautifySelect2Container: function () {
    $(".verse-navigation-container .select2-selection").each(function () {
      $(this)
        .height($(".verse-navigation-container .btn").innerHeight())
        .css("margin-top", "4px");
    });

    $(".verse-navigation-container .select2-selection__rendered").each(
      function () {
        $(this).css("margin-top", "6px");
      }
    );

    $(".verse-navigation-container .select2-selection__arrow").each(
      function () {
        $(this).css("margin-top", "9px");
      }
    );
  },

  gotoVerseId: function () {
    var url = $(this).attr("data-base-url") + $(this).val();
    console.log(url);
    window.location = url;
  },
};


$(document).ready(function () {
  if($(".verse-navigation-container .verse_id_navigation").length > 0) {
    verseNavigationSelect.init();
  } else {
    verseNavigationSelect = null;
  }

});
